/**
 * Shared hook for allocating character stat points.
 * Used by FishingStatsPanel and PlayerProgressionPanel.
 */

import { useGameStore } from '@/state';
import { allocateStatPoint, EntityStats } from '@/types/progression';
import { equipmentManager } from '@/systems/equipment/EquipmentManager';
import { saveManager } from '@/systems/persistence/SaveManager';

export function useStatAllocation() {
  const handleAllocateStat = (stat: keyof EntityStats) => {
    useGameStore.setState((draft) => {
      const newProgression = allocateStatPoint(draft.playerState.progression, stat);
      if (newProgression) {
        draft.playerState.progression = newProgression;
        console.log(`✨ Allocated stat point to ${stat}`);
      }
    });

    equipmentManager.recalculateStats();
    saveManager.save();
    console.log(`💾 Stat allocation saved`);
  };

  return { handleAllocateStat };
}
